<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { YarismaciService } from '@/services/yarismaci'
import JwtService from '@/services/jwt'
import BaglantiHizi from '@/components/BaglantiHizi.vue'
import LogService, { LogIslem, LogSayfa } from '@/services/log.ts'
import Modal from '@/components/Modal.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'
import YarismaService from '@/services/yarisma'
import SiteAyarService from '@/services/site_ayar'
import type { ISiteAyar } from '@/model/site_ayar'
import { ErrorToast } from '@/utils/popup'

const router = useRouter()
const { t } = useI18n()
const closeModalRef = ref<InstanceType<typeof Modal>>()

const adSoyad = ref('')
const siteAyar = ref<ISiteAyar | null>(null)
const loading = ref(false)

const onCikis = () => {
  LogService.log(LogSayfa.YARISMA, LogIslem.YARISMA_CIKIS_ONAY)
  JwtService.destroyTokens()
  YarismaService.clear()
  router.push('/giris')
}

const openModal = () => {
  LogService.log(LogSayfa.YARISMA, LogIslem.YARISMA_CIKISA_BASTI)
  closeModalRef.value?.openModal()
}
const closeModal = () => {
  LogService.log(LogSayfa.YARISMA, LogIslem.YARISMA_CIKIS_VAZGECTI)
  closeModalRef.value?.closeModal()
}

onMounted(async () => {
  loading.value = true
  const [err, ayar] = await SiteAyarService.getSiteAyar()
  loading.value = false
  if (err) {
    ErrorToast(t('error_page.error_occurred'))
    await router.push({
      path: '/error',
      query: {
        status: '500',
        message: t('error_page.error_try_again') + ' ' + err,
        force: 'true',
      },
    })
    return
  }
  siteAyar.value = ayar
  adSoyad.value = YarismaciService.getYarismaciIsmi()
})
</script>

<template>
  <div class="w-full">
    <div
      class="flex flex-row items-center md:justify-center justify-start  gap-2 relative w-full mb-4"
    >
      <div v-if="loading" class="w-40 h-14 bg-gray-200 rounded animate-pulse"></div>
      <div v-else class="flex flex-row flex-wrap items-center gap-3">
        <img
          v-for="(logo, i) in siteAyar?.logo"
          :key="i"
          :src="logo"
          alt="Logo"
          class="w-auto h-14 object-contain px-2"
        />
      </div>
      <div class="absolute inset-y-0 z-10 flex items-center h-full right-1 rtl:right-auto rtl:left-1">
        <LanguageSwitcher />
      </div>
    </div>

    <div
      class="card w-full h-18 md:h-22 p-3 space-y-2 flex items-center justify-between px-4 md:px-6"
    >
      <div class="flex items-center justify-start gap-2">
        <BaglantiHizi />
        <h1 class="text-title-md mb-0">{{ adSoyad }}</h1>
      </div>
      <button type="button" class="btn btn-danger w-16" @click="openModal">{{ $t('out') }}</button>
    </div>
    <Modal ref="closeModalRef">
      <div class="card p-4 flex flex-col items-center justify-center max-w-sm mx-auto rounded-4xl">
        <span class="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-full mb-4">
          <MIcon name="error" size="20px" class="text-gray-700" />
        </span>

        <h1 class="text-title-md text-blue-600">{{ $t('logout') }}</h1>
        <p class="text-body-md text-gray-700 text-center mt-2 text-pretty">
          {{ $t('logout_description') }}
        </p>

        <div class="flex items-center justify-between w-full gap-2 mt-10">
          <button class="btn btn-status-default w-1/2" @click="closeModal">
            {{ $t('giveup') }}
          </button>
          <button class="btn btn-primary w-1/2" @click="onCikis">{{ $t('logout') }}</button>
        </div>
      </div>
    </Modal>
  </div>
</template>
